import {useEffect, useState, useRef} from 'react';

import {useGlobalState} from 'hooks/useGlobalState';
import './ScaleContent.scss';

interface IContentProps {
  styles: object;
}

interface IProps {
  content: React.FC<IContentProps>;
}

export default function ScaleContent({content: Content}: IProps) {
  const [scale, setScale] = useState<number>(1);
  const [height, setHeight] = useState<number>();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const {postWidth, postHeight, postType} = useGlobalState((state) => state.postGenerator);

  useEffect(() => {
    if (containerRef.current) {
      const {clientWidth, clientHeight} = containerRef.current;
      // Calculates proportional scale based on available width/height of container and content (post width/height)
      const newScale = Math.min(clientWidth / postWidth, clientHeight / postHeight);

      setScale(newScale);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      // Calculates height based on aspect ratio
      const newHeight = (postHeight / postWidth) * containerRef.current.clientWidth;

      setHeight(newHeight > postHeight ? postHeight : newHeight);
    }
    // eslint-disable-next-line
  }, [postType]);

  const contentStyles = {
    position: 'relative',
    left: '50%',
    top: '50%',
    transform: `translate(-50%, -50%) scale(${scale > 1 ? 1 : scale})`,
  };

  return (
    <div className="scale-content" ref={containerRef}>
      <div className="scale-content__container" style={{height}}>
        <Content styles={contentStyles} />
      </div>
    </div>
  );
}
